(function (Helper) {

    Helper.stopVideo = function (that, event) {

        $iframe = that.find( "iframe" );
        $iframe.attr("src", $iframe.attr("src"));

    };

     Helper.validateEmail = function (email) {

        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);

    };



}(window.Helper = window.Helper || {}));


